export default "__VITE_ASSET__67f0e450__"